export default __webpack_public_path__ + "static/media/ARB_White.25c024b0.png";